export default "__VITE_ASSET__CDUl8MIo__"